export default __webpack_public_path__ + "static/media/password-icon.860a944f.svg";